import { Box } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import sxClasses from "../flowdesigner.styles";
import securityService from "core/services/securityService/securityService";
import licenseService from "core/services/metaStoreService/license-service";
import HaltExceptionMessageBox from "../message-boxes/halt-exception-message-box";
import Flow from "./flow";
import { useAppStatus, useDragAndDrop } from "../helpers/flow.hooks";
import { useParams } from "react-router";
import { componentDnDDataTransfer } from "app/components/flow/designer/leftSidebar/Components/componentDnD.utils";

import FlowMessageBox from "app/components/flow/designer/graphNodes/FlowMessageBox";
import StreamPreviewContainer from "../stream-preview/stream-preview-table/stream-preview-container";
import { FlowUrlProps } from "../flowdesigner";
import { useNodeDragInteraction } from "../helpers/node.utils";

const FlowContainer: React.FC<{ promptIfUnsavedChanged?: () => Promise<boolean> }> = ({ promptIfUnsavedChanged }) => {
    const { appName, flowName } = useParams<FlowUrlProps>();
    const { onDragOver, onDrop } = useDragAndDrop(appName, flowName, promptIfUnsavedChanged);

    const { handleDragOver, clearDropHighlight, clearDimming } = useNodeDragInteraction(onDragOver);

    const handleDrop = useCallback(
        (event: React.DragEvent<HTMLDivElement>) => {
            clearDropHighlight();
            clearDimming();
            onDrop(event, componentDnDDataTransfer);
        },
        [onDrop, clearDropHighlight, clearDimming]
    );
    const showFlowMessageBox = useMemo(() => {
        return securityService.isFabricSolution() && !(licenseService as any).isLiteLicense;
    }, []);

    return (
        <Box id="flowDesignerContainer" sx={sxClasses.reactFlowWrapper} onDrop={handleDrop} onDragOver={handleDragOver}>
            {showFlowMessageBox && <FlowMessageBox />}
            <HaltExceptionMessageBox appName={appName} flowName={flowName} />
            <Flow promptIfUnsavedChanged={promptIfUnsavedChanged} />
        </Box>
    );
};

export default FlowContainer;
